// =====================================================================
// CalendarView (Quadros PRO / Onda 1 / S60) — cards por data de prazo.
// Grade mensal sem dependência externa. Clicar abre o card.
// =====================================================================
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, IconButton, Paper } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const WD = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
const MN = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

const useStyles = makeStyles((theme) => ({
  grid: { display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 4 },
  cell: { minHeight: 88, padding: 4, display: "flex", flexDirection: "column", gap: 2, overflow: "hidden" },
  head: { textAlign: "center", fontWeight: 700, color: theme.palette.text.secondary, fontSize: 12, padding: 4 },
  chip: {
    fontSize: 11, padding: "1px 4px", borderRadius: 4, background: theme.palette.action.hover,
    cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
  }
}));

const CalendarView = ({ board, onOpenCard }) => {
  const classes = useStyles();
  const [cursor, setCursor] = useState(() => { const d = new Date(); d.setDate(1); d.setHours(0, 0, 0, 0); return d; });
  const year = cursor.getFullYear();
  const month = cursor.getMonth();
  const firstDow = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cards = (board.lists || []).flatMap((l) => (l.cards || []).map((c) => ({ ...c, listName: l.name })));
  const byDay = {};
  cards.forEach((c) => {
    if (!c.dueDate) return;
    const [y, m, d] = String(c.dueDate).slice(0, 10).split("-").map(Number);
    if (y === year && m - 1 === month) (byDay[d] = byDay[d] || []).push(c);
  });

  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: 12, marginBottom: 8 }}>
        <IconButton size="small" onClick={() => setCursor(new Date(year, month - 1, 1))}><ChevronLeftIcon /></IconButton>
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>{MN[month]} {year}</Typography>
        <IconButton size="small" onClick={() => setCursor(new Date(year, month + 1, 1))}><ChevronRightIcon /></IconButton>
      </Box>
      <div className={classes.grid}>
        {WD.map((w) => <div key={w} className={classes.head}>{w}</div>)}
        {cells.map((d, i) => (
          <Paper key={i} variant="outlined" className={classes.cell} style={{ visibility: d ? "visible" : "hidden" }}>
            {d ? <Typography variant="caption" color="textSecondary">{d}</Typography> : null}
            {(byDay[d] || []).map((c) => (
              <div key={c.id} className={classes.chip} title={`${c.title} · ${c.listName}`} onClick={() => onOpenCard(c)}
                style={{ borderLeft: `3px solid ${c.coverColor || "#90a4ae"}`, textDecoration: c.done ? "line-through" : "none" }}>
                {c.done ? "✓ " : ""}{c.title}
              </div>
            ))}
          </Paper>
        ))}
      </div>
    </Box>
  );
};

export default CalendarView;
